import React from 'react';
import { Zap, Plus, Menu } from 'lucide-react';

/**
 * 사이드바 최상단 헤더 컴포넌트.
 * 닫힘: ≡ 토글 → + 새채팅 순서로 아이콘만 표시
 * 열림: ≡ + 로고 텍스트 한 줄, 새 채팅 버튼
 */
const SidebarHeader = ({ onNewChat, setActiveTab, isOpen, onToggleSidebar }) => {
    if (!isOpen) {
        return (
            <div className="flex flex-col items-center gap-1 pb-2">
                <button
                    onClick={onToggleSidebar}
                    title="사이드바 열기"
                    className="h-1 flex items-center justify-center rounded-xl text-gray-500 hover:bg-white hover:text-gray-700 hover:shadow-sm transition-all"
                >
                    <Menu size={20} />
                </button>
                <button
                    onClick={() => { onNewChat(); setActiveTab('chat'); }}
                    title="새 채팅 시작"
                    className="h-1 flex items-center justify-center rounded-xl text-gray-500 hover:bg-white hover:text-blue-600 hover:shadow-sm transition-all"
                >
                    <Plus size={20} />
                </button>
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-2 pb-2">
            <div className="flex items-center gap-1 pt-1">
                <button
                    onClick={() => setActiveTab('chat')}
                    className="flex items-center gap-2 px-2 py-1 rounded-xl hover:bg-white/60 transition-all text-left overflow-hidden group"
                    style={{ minWidth: 0 }}
                >
                    <div className="p-1.5 bg-blue-600 rounded-lg text-white group-hover:bg-blue-700 transition-colors flex-shrink-0">
                        <Zap size={16} fill="currentColor" />
                    </div>
                    <span className="font-black text-gray-900 text-base tracking-tight truncate">산업안전 AI 알리미</span>
                </button>
            </div>

            <button
                onClick={() => { onNewChat(); setActiveTab('chat'); }}
                className="flex items-center gap-3 px-4 py-2.5 mx-1 bg-white border border-gray-200 rounded-xl shadow-sm text-base font-bold text-blue-600 hover:border-blue-300 hover:bg-blue-50 transition-all group"
            >
                <Plus size={16} className="text-blue-500 group-hover:scale-110 transition-transform flex-shrink-0" />
                <span>새 채팅 시작</span>
            </button>
        </div>
    );
};

export default SidebarHeader;
